import React from "react";

import {
  Distance,
  QueryRuleValue,
  NumericRange,
  DateTimeStrings,
  DateTimeRange,
} from "../types";
import Context from "../Context";
import DistanceValue from "../Distance/DistanceValue";
import BooleanValue from "../Boolean/BooleanValue";
import Numeric from "../Numeric/Numeric";
import TextValue from "../TextValue/TextValue";
import DateTimeValue from "../DateTime/DateTimeValue";

interface ValueInputProps {
  id: number;
  attribute?: string;
  operator?: string;
  value?: QueryRuleValue;
}

const ValueInput = ({
  id,
  attribute,
  operator,
  value: valueProp,
}: ValueInputProps): JSX.Element => {
  const context = React.useContext(Context);

  const { attributes, initialTouched } = context;

  const { type } = attribute ? { ...attributes[attribute] } : { type: null };

  switch (type) {
    case "distance": {
      return (
        <DistanceValue
          id={id}
          value={valueProp as Distance}
          initialTouched={initialTouched}
        />
      );
    }
    case "boolean": {
      return (
        <BooleanValue
          id={id}
          value={valueProp as boolean}
          initialTouched={initialTouched}
        />
      );
    }
    case "numeric": {
      return (
        <Numeric
          id={id}
          operator={operator as string}
          value={valueProp as number | NumericRange}
          initialTouched={initialTouched}
        />
      );
    }
    case "text":
    case "textarea": {
      return (
        <TextValue
          id={id}
          value={valueProp as string}
          initialTouched={initialTouched}
        />
      );
    }
    case "dateandtime": {
      return (
        <DateTimeValue
          id={id}
          operator={operator as string}
          value={valueProp as DateTimeStrings | DateTimeRange}
          initialTouched={initialTouched}
        />
      );
    }
    default: {
      return <></>;
    }
  }
};

export default React.memo(ValueInput);
